import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from "react-router";
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import { getTheme, setApplicationFlow, setTheme } from '../../Utils/Utility';
// import '../../styles/style_wizard.css';
import { FaShippingFast } from "react-icons/fa";
import { GiSteeringWheel } from "react-icons/gi";
import LanguageSelection from '../LanguageSelection/LanguageSelection';
import { getCountryList } from '@mobile-dev/platform/common/redux/actions/GetCountries';
import { getCaptcha } from '@mobile-dev/platform/common/redux/actions/Captcha';
import { clearError } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import { useDispatch, useSelector } from "react-redux"

function LandingPage() {
    const dispatch = useDispatch()
    const captchaError = useSelector(state => state.captcha.error);

    useEffect(() => {
        let theme = getTheme();
        localStorage.clear();
        setTheme(theme);
        dispatch(getCountryList());
        dispatch(getCaptcha())
    }, [])

    useEffect(() => {
        if (captchaError) {
            dispatch(clearError())
            dispatch(getCaptcha())
        }
    }, [captchaError])

    const history = useHistory();
    const handleChange = (e) => {
        if (e.target.value === "Carrier") {
            setApplicationFlow('Carrier');
            history.push({ pathname: '/carrierLogin' });
            return null;
        }
        else {
            setApplicationFlow('Driver');
            history.push({ pathname: '/signin' });
            return null;
        }
    }

    return (
        <form className="form-signin" action="skip.html">
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FrieghtSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <h4 className="text-dark-50 text-center mt-0 font-weight-bold mb-4">Are you a <span className="remaining_amt">Carrier</span> (or) <span className="remaining_amt">Driver</span>?</h4>

                    </div>
                    <div className="row mb-4">
                        <div className="mx-auto d-flex">
                            <div className="purpose-radio">
                                <input type="radio" name="Selection" id="carrier-book" className="purpose-radio-input"
                                    value="Carrier" onChange={handleChange} />
                                <label htmlFor="carrier-book" className="purpose-radio-label">
                                    <span className="label-icon">
                                        {/* <i className="fad fa-money-check-edit-alt fa-3x"></i> */}
                                        {/* <img src={carrierIcon} alt="" className="fad fa-3x"/> */}
                                        < FaShippingFast className='fad fa-3x' />
                                    </span>
                                    <span className="label-text">Carrier</span>
                                </label>
                            </div>
                            <div className="purpose-radio">
                                <input type="radio" name="Selection" id="driver-card" className="purpose-radio-input"
                                    value="Driver" onChange={handleChange} />
                                <label htmlFor="driver-card" className="purpose-radio-label">
                                    <span className="label-icon">
                                        < GiSteeringWheel className='fa-3x' />
                                    </span>
                                    <span className="label-text">Driver</span>
                                </label>
                            </div>

                        </div>
                    </div>

                    <LanguageSelection />

                </div>

            </div>
            <h6 className="text-dark-50 text-center mt-0 mb-4"><span className="remaining_amt"> App Version {process.env.REACT_APP_VERSION}</span></h6>
        </form>
    )

}

export default LandingPage;